<script>
import AppCollapseChild from '@/components(new)/UI/Collapse/CollapseChild.vue'
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'
import FormularioPraticas from './form-praticas'
import modelsPraticas from '@/libs/models/cadastro/praticas'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import * as georreferenciamentoService from '@/services/georreferenciamento'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    AppCollapseChild,
    CustomButton
  },
  mixins: [AppNotificacao],
  props: {
    cadastro: {
      type: Object,
      required: true
    },
    observer: {
      required: true
    },
    protocolo: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      praticasAtivas: [],
      praticasList: [
        {
          codigo: 'PRPD',
          titulo: 'Práticas para Recuperação de Pastagens Degradadas (PRPD)',
          descricao: `São ações/técnicas para melhorar uma pastagem que está
          fraca ou improdutiva,  melhorando a terra e o solo para desempenhar a pecuária.`,
          componente: FormularioPraticas.PRPD,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'SPDG',
          titulo: 'Sistema de Plantio Direto de Grãos (SPDG)',
          descricao: `Técnica que mantém o solo coberto com a palha da plantação anterior,
          sem arar a terra. Isso preserva a umidade, aumentando a produtividade de grãos.`,
          componente: FormularioPraticas.SPDG,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'SPDH',
          titulo: 'Sistema de Plantio Direto de Hortaliças (SPDH)',
          descricao: `Adaptação do plantio direto para hortaliças, mantendo o solo coberto de palha,
          adubação orgânica e preparo mínimo.`,
          componente: FormularioPraticas.SPDH,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'ILPF',
          titulo: 'Integração Lavoura-Pecuária-Floresta (ILPF)',
          descricao: `Combinação de agricultura, pecuária e cultivo de árvores/florestas
          na mesma área, promovendo produção sustentável e diversificada`,
          componente: FormularioPraticas.ILPF,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'SAF',
          titulo: 'Sistemas Agroflorestais (SAF)',
          descricao: `Cultivo conjunto de árvores, lavouras e/ou animais,
          imitando a diversidade  natural e promovendo conservação ambiental.`,
          componente: FormularioPraticas.SAF,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'FP',
          titulo: 'Florestas Plantadas (FP)',
          descricao: `Plantio de árvores para vender madeira, proteger nascentes
          ou recuperar áreas.  Pode usar árvores nativas ou de outras espécies.`,
          componente: FormularioPraticas.FP,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'MRPA',
          titulo: 'Manejo de Resíduos da Produção Animal (MRPA)',
          descricao: `Práticas que tratam e reaproveitam os resíduos de animais,
          evitando impactos ambientais e promovendo fertilização.`,
          componente: FormularioPraticas.MRPA,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'TI',
          titulo: 'Terminação intensiva (TI)',
          descricao: `Engorda de animais em confinamento ou semiconfinamento
          com alimentação controlada e alta eficiência.`,
          componente: FormularioPraticas.TI,
          visivel: false,
          disabled: false
        },
        {
          codigo: 'NONE',
          titulo: 'Nenhuma prática exercida no momento, mas desejo começar',
          descricao: `Ainda não uso nenhuma dessas práticas no imóvel,
          mas quero aprender e começar a usar.`,
          componente: FormularioPraticas.NONE,
          visivel: false,
          disabled: false
        }
      ]
    }
  },
  computed: {
    praticaSelecionada () {
      const praticasVisiveis = this.praticasList.filter(p => p.visivel)
      if (praticasVisiveis.some(p => p.codigo === 'NONE')) {
        return 'sim'
      }
      let praticasPreenchidas = 0
      if (this.cadastro.praticas) {
        Object.keys(this.cadastro.praticas).forEach(key => {
          if (key.startsWith('praticaSustentavel') && this.cadastro.praticas[key]) {
            if (key.includes('SPDG') || key.includes('SPDH')) {
              if (Array.isArray(this.cadastro.praticas[key]) && this.cadastro.praticas[key].length > 0) {
                praticasPreenchidas++
              }
            } else {
              if (typeof this.cadastro.praticas[key] === 'object' && this.cadastro.praticas[key] !== null) {
                praticasPreenchidas++
              }
            }
          }
        })
      }
      return praticasPreenchidas > 0 ? 'sim' : ''
    }
  },
  mounted () {
    if (this.cadastro.praticas && Object.keys(this.cadastro.praticas).length) {
      this.praticasList.forEach(pratica => {
        if (!['SPDG', 'SPDH'].includes(pratica.codigo)) {
          if (this.cadastro.praticas[`praticaSustentavel${pratica.codigo}`]) {
            pratica.visivel = true
          }
        } else {
          if (this.cadastro.praticas[`praticaSustentavel${pratica.codigo}`]?.length
          ) {
            pratica.visivel = true
          }
        }
      })
    } else {
      this.praticasList.forEach(p => {
        if (p.codigo === 'NONE') {
          p.visivel = true
          this.praticasAtivas.push('NONE')
        } else {
          p.disabled = true
        }
      })
    }
  },
  methods: {
    changeForms (pratica) {
      if (pratica.codigo === 'NONE') {
        if (pratica.visivel) {
          this.praticasAtivas.push(pratica.codigo)
          const keysToRemove = [
            'praticaSustentavelPRPD',
            'praticaSustentavelSPDG',
            'praticaSustentavelSPDH',
            'praticaSustentavelILPF',
            'praticaSustentavelSAF',
            'praticaSustentavelFP',
            'praticaSustentavelMRPA',
            'praticaSustentavelTI'
          ]
          this.confirmBox('Ao selecionar essa opção, os dados preenchidos nas outras práticas serão perdidos. Deseja realmente continuar?',
            this.$messages.TITULO_WARNING,
            async () => {
              keysToRemove.forEach(key => delete this.cadastro.praticas[key])

              this.praticasList = this.praticasList.map(p => p.codigo !== 'NONE'
                ? { ...p, disabled: true, visivel: false }
                : { ...p }
              )
            },
            () => {
              pratica.visivel = false
            }, 'Confimar', 'Cancelar')
        } else {
          this.praticasList = this.praticasList.map(p => ({
            ...p,
            disabled: false
          }))
        }
      } else {
        if (pratica.visivel) {
          this.praticasAtivas.push(pratica.codigo)
          this.cadastro.praticas[`praticaSustentavel${pratica.codigo}`] = _.cloneDeep(modelsPraticas[pratica.codigo])
          if (!['SPDG', 'SPDH'].includes(pratica.codigo)) {
            this.cadastro.praticas[`praticaSustentavel${pratica.codigo}`] = {
              ...this.cadastro.praticas[`praticaSustentavel${pratica.codigo}`],
              id: uuidv4()
            }
          }
        } else {
          this.deleteGeometriaPratica(pratica.codigo)
          delete this.cadastro.praticas[`praticaSustentavel${pratica.codigo}`]
          this.praticasAtivas = this.praticasAtivas.filter(p => p !== pratica.codigo)
        }
      }
      this.$emit('add-pratica')
    },

    async deleteGeometriaPratica (codigoPratica) {
      try {
        await georreferenciamentoService.deleteGeorreferenciamentoPratica(this.protocolo, codigoPratica)
        this.$emit('pratica-removida', codigoPratica)
      } catch (error) {
        console.error('Erro ao deletar geometria da prática:', error)
      }
    }
  }
}
</script>

<template>
  <div>
    <!-- Campo de validação oculto para garantir que pelo menos uma prática seja selecionada -->
    <validation-provider
      name="Práticas/praticas_obrigatorias"
      :rules="{ required: true }"
      v-slot="{ errors }"
    >
      <input type="hidden" v-model="praticaSelecionada" />
      <span class="error-message" v-if="errors[0]">{{ errors[0] }}</span>
    </validation-provider>

    <el-collapse v-model="praticasAtivas">
      <el-collapse-item v-for="(pratica, index) in praticasList" :key="pratica.codigo" :name="pratica.codigo" :disabled="!pratica.visivel">
        <template slot="title">
          <el-checkbox
            :class="index > 0 ? 'mt-2' : ''"
            v-model="pratica.visivel"
            @change="changeForms(pratica)"
            :disabled="pratica.disabled"
          >
            {{ pratica.titulo }}
          </el-checkbox>
        </template>
        <el-form v-if="pratica.visivel" class="mt-3 mb-2">
          <component
            :is="pratica.componente" :observer="observer"
            :pratica="cadastro.praticas[`praticaSustentavel${pratica.codigo}`]"
            :cadastro="cadastro"
          />
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/praticas.vue